<template>
  <div class="account-email">
    <div class="account-label">{{ label }}</div>
    <div class="row">
      <div class="col">
        <input
          type="text"
          class="form-control form-control-sm"
          :class="{ 'is-invalid': !isValid && emailValue !== '' }"
          v-model="emailValue"
        />
      </div>
      <div class="col-auto">
        <button
          class="btn btn-sm btn-primary"
          :disabled="email === emailValue || !isValid"
          @click="$emit('action', emailValue)"
        >
          {{ button }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}
export default {
  name: 'account-email-control',
  props: {
    email: String,
    label: String,
    button: String
  },
  data() {
    return {
      emailValue: this.email
    }
  },
  computed: {
    isValid() {
      return validateEmail(this.emailValue)
    }
  },
  watch: {
    email() {
      this.emailValue = this.email
    }
  }
}
</script>

<style lang="scss">
.account-email {
  &__heading {
    margin-bottom: 0.5rem;
    font-size: 14px;
  }
}
</style>
